import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { useRef, useState } from "react";
import { addLacreManifesto, removerLacreManifesto, removerLacreManifestoTodos } from "../../../features/manifestoSlice";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../components/Components";
import { LacresManifestoInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { getUuidV4, goToFocus } from "../../../utils/utils";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialForm: LacresManifestoInterface = {
    id: 0,
    numero: ''
}

export default function LacresManifesto() {
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.lacres);
    const [form, setForm] = useState<LacresManifestoInterface>(initialForm);
    const numeroRef = useRef<HTMLInputElement>(null);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [selecionado, setSelecionado] = useState<number | string>('');
    const validarPreenchimento = () => {
        if (form.numero.trim() === "") {
            goToFocus(numeroRef);
            alertModal('Informe o número do lacre.');
            return false;
        }

        if (lista.find((item: LacresManifestoInterface) => item.numero === form.numero)) {
            goToFocus(numeroRef);
            alertModal('Número do lacre já foi adicionado.');
            return false;
        }
        return true;
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            dispatch(addLacreManifesto({
                id: getUuidV4(),
                numero: form.numero
            }));
            setForm(initialForm);
            goToFocus(numeroRef);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        const confirmed = await confirm({
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
            title: "Confirmação"
        });

        if (confirmed) {
            dispatch(removerLacreManifesto(value.id));
        }
        setSelecionado('');
    }

    const removerTudo = async () => {
        if (lista.length > 0) {
            const confirmed = await confirm({
                message: <>Deseja realmente remover todos os lacres ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removerLacreManifestoTodos());
            }
        }
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return <div className="px-2">

        <Row className="g-2 mb-3">
            <Col md={2} >
                <Form.Group controlId="lacre-manifesto-numero">
                    <Form.Label>Número do lacre</Form.Label>
                    <InputGroup>
                        <Form.Control placeholder="" maxLength={60} type="text"
                            value={form.numero} name="numero" onChange={handleChange}

                            ref={numeroRef}
                        />
                        <Button variant="primary" onClick={handleAdd}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>

        <JTable>
            <JTHead>
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>
                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                    </th>
                    <th>Número do lacre</th>
                </tr>
            </JTHead>

            <JTBody>
                {lista.map((item: LacresManifestoInterface) => (
                    <tr key={item.id} className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                        <td className="text-center">
                            <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.numero })} />
                        </td>
                        <td>{item.numero}</td>
                    </tr>
                ))}
            </JTBody>
        </JTable>
        {ConfirmModal}
        {ModalMessageEl}
    </div>
}
